import 'ant-design-vue/dist/reset.css';
import './assets/styles/styles.scss';
import './assets/styles/ant-design.scss';
import 'dayjs/locale/ru';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import components from '@/components/UI';
import Antd from 'ant-design-vue';
import connectBackend from '@/services/backend/connect';
import connectKeycloak from '@/services/keycloak/connect';
import 'ant-design-vue/dist/reset.css';
import { configure as configureDayjs } from './lib/dayjs/config';

const app = createApp(App);

components.forEach((component) => {
  app.component(component.name, component);
});

connectBackend(app);
connectKeycloak(app);
configureDayjs();

// TODO: использовать https://github.com/antfu/unplugin-vue-components вместо кучи use() для каждого компонента ant design
// Справка: https://antdv.com/docs/vue/introduce#use-modularized-ant-design-vue
app.use(router).use(store).use(Antd).mount('#app');
